import React from 'react'
import { FormattedMessage } from 'react-intl'
import { codify } from '../'
import { Section, Heading } from '../s'
import Paragraph from 'components/typography/paragraph'
import Divider from 'components/divider'

const WebhookGroupEvents = () => (
    <Section>
        <Heading>
            <FormattedMessage
                id="integration_webhook_heading_group_events"
                defaultMessage="Team and location events" />
        </Heading>
        <Paragraph>
            <FormattedMessage
                id="integration_webhook_description_group_events"
                defaultMessage="All team and location event request bodies include a <code>groups</code> array, which contains an object for each affected team or location. Each group object will always contain a unique and unchanging <code>id</code> field, the group <code>name</code>, and the group <code>type</code>, which will be either <code>team</code> or <code>location</code>."
                values={{ code: codify }} />
        </Paragraph>
        <Divider />
    </Section>
)

export default WebhookGroupEvents